export default __webpack_public_path__ + "static/media/rester_informe.e180af0d.png";